import { format } from 'date-fns';

import { formatPoints, toBigInt } from '@/app/shared/lib/formatters';

export const hasPoints = (raw: string): boolean => toBigInt(raw) > 0n;

export const formatEarned = (points: string | number | null | undefined): string => {
  if (points == null || points === '') return '-';
  if (typeof points === 'number') {
    if (points > 0) return `+${points.toLocaleString('en-US')} pts`;
    return '-';
  }
  if (!hasPoints(points)) return '-';
  return `+${formatPoints(points)} pts`;
};

export const formatLastUpdated = (value: string | number): string | null => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  const time = date
    .toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'UTC' })
    .replace(/\s/g, '')
    .toUpperCase();
  const day = date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
  return `Last updated ${time} UTC, ${day}`;
};

export const formatActivityDate = (date: string): string => {
  try {
    return format(new Date(date), 'MMM d, yyyy');
  } catch {
    return date;
  }
};

export const formatLeaderboardPointsLabel = (totalPoints: string, isYou = false): string => {
  if (isYou && !hasPoints(totalPoints)) return '--';
  return formatPoints(totalPoints);
};
